import {GridCellKind} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridCellKind';
import {IGridCellRenderer} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';

export class GridRendererRegistry
{
    private _kindToRenderer:Map<GridCellKind, IGridCellRenderer> = new Map();

    public register(kind:GridCellKind, renderer:IGridCellRenderer):void
    {
        this._kindToRenderer.set(kind, renderer);
    }

    public getRendererFor(kind:GridCellKind):IGridCellRenderer
    {
        return this._kindToRenderer.get(kind);
    }
}
